import { SearchResultLayout } from "@me8eon/data_views";
import React from "react";
import { useTheme } from "@me8eon/themes";

export const AllDataViewSearchResultLayout: SearchResultLayout =
    ({ rootId, children }) => {
        const childrenAsArray = React.Children.toArray(children);
        if (childrenAsArray.length !== 2) throw new Error("Expected three children");
        const [rest, sharepoint] = childrenAsArray;
        const { dataLayout } = useTheme();
        return <div className="advance-page-result-root" data-testid={`${rootId}-search-result-layout`}>
            <hr style={{ margin: 0, backgroundColor: "#e8e3e0", height: "2px", border: "none", position: "sticky", top: "163px", zIndex: 98 }} />
            <div className="all_data_view_row_2">
                <div className="sharepoint-wrapper" style={dataLayout.AdvanceUnifiedBox}>
                    {sharepoint}
                </div>
                <div className="all-list-wrapper">
                    {rest}
                </div>
            </div>
        </div>;
    };